const College = () => {
    return (
        <div className="aboutMeContent">
			<h1 className="heading1">College</h1>

			<p className="text">
                I'm currently attending Champlain College going into my
                3rd year.
            </p>

            <p className="text">
                I've had a lot of fun with improving my programming skills
                over the past 2 years and continue to learn web development
                on my own
            </p>

            <p className="text">
                There's still a lot to do, so the grind NEVER STOPS!!!
            </p>
		</div>
    )
}

export default College;